import { useEffect } from 'react';

const MODAL_LOCK_ATTR = 'data-modal-lock-count';

const updateLockCount = (delta) => {
  if (typeof document === 'undefined') {
    return () => {};
  }

  const html = document.documentElement;
  const body = document.body;
  const currentCount = Number(body.getAttribute(MODAL_LOCK_ATTR) || '0');
  const nextCount = Math.max(0, currentCount + delta);

  if (nextCount === 0) {
    body.removeAttribute(MODAL_LOCK_ATTR);
    body.classList.remove('modal-open');
    html.classList.remove('modal-open');
    return () => {};
  }

  body.setAttribute(MODAL_LOCK_ATTR, String(nextCount));
  body.classList.add('modal-open');
  html.classList.add('modal-open');

  return () => {
    updateLockCount(-1);
  };
};

const useMobileModalMode = (isActive) => {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    return updateLockCount(1);
  }, [isActive]);
};

export default useMobileModalMode;
